module.exports = __webpack_public_path__ + "img/icon-delete.7b7e5698.svg";